import { connectLimitOrderMessages } from 'components/secondaryMarket/limitOrder/sidePanel/messages.connect';
import { ConnectedPlacedSidePanel } from 'components/secondaryMarket/limitOrder/sidePanel/placed/PlacedSidePanel.connect';
import type { LimitOrderSidePanelProps } from 'components/secondaryMarket/limitOrder/sidePanel/sidePanel.connect';
import { ErrorSidePanel } from 'components/secondaryMarket/shared/SidePanel/ErrorSidePanel';
import { SidePanelStructure } from 'components/secondaryMarket/shared/SidePanel/SidePanelStructure';
import { StreamingBeforeQuotedSidePanel } from 'components/secondaryMarket/shared/SidePanel/StreamingBeforeQuotedSidePanel';
import { ProcessingSidePanel } from 'components/secondaryMarket/shared/SidePanel/TradingSidePanel';
import type { LimitOrderForm } from 'state/secondaryMarket/limit-order/form/input/inputForm.model';

const ConnectedStreamingBeforeQuotedSidePanel = connectLimitOrderMessages(
  StreamingBeforeQuotedSidePanel<LimitOrderForm>,
);

export function LimitOrderSidePanel({
  status,
  errors,
  onTrade,
  kycScore,
  kycDetails,
  errorMessage,
  timeout,
  onDone,
  formId,
  canPlaceOrder,
  backendReports,
}: LimitOrderSidePanelProps) {
  return (
    <SidePanelStructure>
      {(status === 'READY' || status === 'NOT_READY') && (
        <ConnectedStreamingBeforeQuotedSidePanel
          tabId={formId}
          status={status}
          backendReports={backendReports}
          errors={errors}
          kycScore={kycScore}
          kycDetails={kycDetails}
          onQuote={onTrade}
          canQuote={canPlaceOrder}
          isLimitOrder={true}
        />
      )}
      {(status === 'ORDER_REJECTED' || status === 'ORDER_FAILED') && (
        <ErrorSidePanel
          tabId={formId}
          orderActionType={'LIMIT_ORDER'}
          onDone={onDone}
          errorMessage={errorMessage}
          timeout={timeout}
          panelFooterMessageKey={
            status === 'ORDER_REJECTED' ? 'secondaryMarket.sidePanel.label.orderRejected' : undefined
          }
          onQuote={onTrade}
        />
      )}
      {status === 'ORDER_REQUESTED' && <ProcessingSidePanel />}
      {status === 'ORDER_PLACED' && <ConnectedPlacedSidePanel formId={formId} />}
    </SidePanelStructure>
  );
}
